import { render, staticRenderFns } from "./FlashProducts.vue?vue&type=template&id=6139d1b0&scoped=true"
import script from "./FlashProducts.vue?vue&type=script&lang=js"
export * from "./FlashProducts.vue?vue&type=script&lang=js"
import style0 from "./FlashProducts.vue?vue&type=style&index=0&id=6139d1b0&prod&scoped=true&lang=css"
import style1 from "./FlashProducts.vue?vue&type=style&index=1&id=6139d1b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6139d1b0",
  null
  
)

export default component.exports